module.exports = __webpack_public_path__ + "img/main_img1.64d4b6ea.jpg";